// Site registration, detail, plan editing, suspension.
export const siteDetailEn = {
  'sites.register': 'Register site',
  'sites.register.title': 'Register a site',
  'sites.register.hint': 'Enter the site as it is deployed. The console checks that it answers with this secret before saving.',
  'sites.register.name': 'Name',
  'sites.register.slug': 'Short name',
  'sites.register.slugHint': 'Lowercase letters, numbers and dashes.',
  'sites.register.webUrl': 'Website URL',
  'sites.register.adminUrl': 'CMS URL',
  'sites.register.secret': 'Control secret',
  'sites.register.secretHint': 'The CONTROL_SECRET configured on the site (at least 32 characters). It is stored encrypted and never shown again.',
  'sites.register.notes': 'Notes',
  'sites.register.submit': 'Check and register',
  'sites.register.submitting': 'Checking…',
  'sites.register.done': '{name} was registered',
  'sites.syncAll': 'Sync all',
  'sites.syncAll.done': 'Synced {synced}, failed {failed}',
  'site.back': 'Sites',
  'site.openWeb': 'Open website',
  'site.openCms': 'Open CMS',
  'site.openCmsAsStaff': 'Open CMS as staff',
  'site.signingIn': 'Signing in…',
  'site.sync': 'Sync now',
  'site.syncing': 'Syncing…',
  'site.sync.done': 'Synced with the site',
  'site.overview': 'Overview',
  'site.package': 'Package',
  'site.status': 'Status',
  'site.environment': 'Environment',
  'site.lastSync': 'Last sync',
  'site.lastEdit': 'Last content change',
  'site.centralLogin': 'Central sign-in',
  'site.centralLogin.on': 'On: admin.digimasi.com',
  'site.centralLogin.off': 'Off: own passwords',
  'site.counts': 'Content',
  'site.counts.value': '{pages} pages · {articles} articles · {products} products · {media} files',
  'site.syncError': 'The last sync failed: {error}',
  'site.usage': 'Usage',
  'site.usage.noData': 'No usage yet. Sync the site to read it.',
  'site.limit.pages': 'Pages',
  'site.limit.users': 'Active users',
  'site.limit.languages': 'Content languages',
  'site.limit.items': 'Catalogue items',
  'site.limit.articles': 'Articles',
  'site.limit.storage': 'Media storage (MB)',
  'site.limit.domains': 'Own domains',
  'site.unlimited': 'Unlimited',
  'site.usedOf': '{used} of {limit}',
  'site.usedOnly': '{used} in use',
  'site.plan': 'Plan',
  'site.plan.hint': 'Changes are sent to the site and confirmed before they are saved here.',
  'site.plan.package': 'Package',
  'site.plan.flags': 'Features',
  'site.plan.limits': 'Limits',
  'site.plan.default': 'Package default',
  'site.plan.on': 'Always on',
  'site.plan.off': 'Always off',
  'site.plan.defaultOn': 'default: on',
  'site.plan.defaultOff': 'default: off',
  'site.plan.custom': 'Custom number',
  'site.plan.defaultLimit': 'Package default ({value})',
  'site.plan.save': 'Save plan',
  'site.plan.saving': 'Saving…',
  'site.plan.saved': 'Plan saved and confirmed by the site',
  'site.plan.confirm.title': 'Change the plan of {name}?',
  'site.plan.confirm.body': 'The site switches to {package} immediately. Content over a lower limit stays readable but cannot be added to.',
  'site.plan.confirm.action': 'Change plan',
  'site.plan.noChange': 'No changes to save.',
  'site.details': 'Details',
  'site.details.save': 'Save details',
  'site.details.saved': 'Details saved',
  'site.details.secretReplace': 'New control secret',
  'site.details.secretReplaceHint': 'Leave empty to keep the current secret.',
  'site.suspension': 'Suspension',
  'site.suspension.hint': 'A suspended site is closed to its own CMS users. The public website keeps running. Console staff can still sign in.',
  'site.suspend': 'Suspend site',
  'site.reactivate': 'Reactivate site',
  'site.suspend.title': 'Suspend {name}?',
  'site.suspend.body': 'Its CMS users are locked out until you reactivate it.',
  'site.suspended': 'Site suspended',
  'site.reactivated': 'Site reactivated',
  'site.remove': 'Remove from console',
  'site.remove.title': 'Remove {name} from the console?',
  'site.remove.body': 'The site itself is not touched; it just stops being managed here.',
  'site.removed': 'Site removed from the console',
  'site.flag.cms': 'CMS sign-in for the customer',
  'site.flag.blog': 'Blog / news',
  'site.flag.lead_capture': 'Lead capture',
  'site.flag.booking': 'Booking embed',
  'site.flag.rename_types': 'Rename catalogue types',
  'site.flag.custom_types': 'Add and delete catalogue types',
  'site.flag.rbac': 'Custom roles (RBAC)',
  'site.flag.multi_location': 'Multiple locations',
  'site.flag.custom_domain': 'Own domain',
  'site.flag.store': 'Online store',
  'site.flag.mailbox': 'Inbox (email to the site domain)',
  'site.flag.ai_writing': 'AI writing assistant',
  'site.flag.seo': 'SEO fields and settings',
  'site.flag.tracking': 'Tracking (Google Analytics, Meta Pixel, TikTok)',
  'site.plan.scopeContent': 'This package opens only page, catalogue and media editing in the CMS: no site settings, navigation, users, articles or quote requests. Console staff are not limited.',
  'apiError.siteNotFound': 'Site not found',
  'apiError.siteExists': 'A site with this name already exists',
  'apiError.siteUnreachable': 'The site could not be reached',
  'apiError.siteTimeout': 'The site did not answer in time',
  'apiError.siteNoSecret': 'The control secret is missing or cannot be read',
  'apiError.siteBadResponse': 'The site sent an unexpected response',
  'apiError.siteRejected': 'The site refused the request (check the control secret and URL)',
  'apiError.siteUpdateFailed': 'The site could not be updated',
  'apiError.siteCheckFailed': 'The site could not be checked',
  'apiError.encryptionKey': 'The console encryption key is not configured',
  'builds.title': 'Website builds',
  'builds.hint': 'Rebuilding publishes the latest CMS content to the public website. CMS saves and code updates start a build on their own.',
  'builds.enabled': 'Builds are on for this site',
  'builds.enabledHint': 'Switch on once the site has a pipeline that can build it.',
  'builds.rebuild': 'Rebuild now',
  'builds.rebuilding': 'Starting…',
  'builds.started': 'Build started',
  'builds.configSaved': 'Build setting saved',
  'builds.empty': 'No builds yet.',
  'builds.col.status': 'Status',
  'builds.col.trigger': 'Started by',
  'builds.col.when': 'Started',
  'builds.col.finished': 'Finished',
  'builds.col.message': 'Note',
  'builds.status.queued': 'Queued',
  'builds.status.running': 'Running',
  'builds.status.succeeded': 'Succeeded',
  'builds.status.failed': 'Failed',
  'builds.status.skipped': 'Skipped',
  'builds.trigger.manual': 'Console',
  'builds.trigger.cms': 'CMS save',
  'builds.trigger.code': 'Code update',
  'builds.trigger.pipeline': 'Pipeline',
  'builds.notConnected': 'Builds are not connected yet: the console has no GitHub token or repository',
  'apiError.buildOff': 'Builds are switched off for this site',
  'apiError.buildRunning': 'A build for this site is already running',
} as const

export const siteDetailId: Record<keyof typeof siteDetailEn, string> = {
  'sites.register': 'Daftarkan situs',
  'sites.register.title': 'Daftarkan situs',
  'sites.register.hint': 'Masukkan situs sesuai yang sudah berjalan. Console memeriksa bahwa situs menjawab dengan secret ini sebelum menyimpan.',
  'sites.register.name': 'Nama',
  'sites.register.slug': 'Nama pendek',
  'sites.register.slugHint': 'Huruf kecil, angka, dan tanda hubung.',
  'sites.register.webUrl': 'URL website',
  'sites.register.adminUrl': 'URL CMS',
  'sites.register.secret': 'Control secret',
  'sites.register.secretHint': 'CONTROL_SECRET yang diatur di situs (minimal 32 karakter). Disimpan terenkripsi dan tidak akan ditampilkan lagi.',
  'sites.register.notes': 'Catatan',
  'sites.register.submit': 'Periksa dan daftarkan',
  'sites.register.submitting': 'Memeriksa…',
  'sites.register.done': '{name} didaftarkan',
  'sites.syncAll': 'Sinkronkan semua',
  'sites.syncAll.done': 'Berhasil {synced}, gagal {failed}',
  'site.back': 'Situs',
  'site.openWeb': 'Buka website',
  'site.openCms': 'Buka CMS',
  'site.openCmsAsStaff': 'Buka CMS sebagai staf',
  'site.signingIn': 'Sedang masuk…',
  'site.sync': 'Sinkronkan',
  'site.syncing': 'Menyinkronkan…',
  'site.sync.done': 'Berhasil disinkronkan dengan situs',
  'site.overview': 'Ikhtisar',
  'site.package': 'Paket',
  'site.status': 'Status',
  'site.environment': 'Lingkungan',
  'site.lastSync': 'Sinkron terakhir',
  'site.lastEdit': 'Perubahan konten terakhir',
  'site.centralLogin': 'Masuk terpusat',
  'site.centralLogin.on': 'Aktif: admin.digimasi.com',
  'site.centralLogin.off': 'Mati: kata sandi sendiri',
  'site.counts': 'Konten',
  'site.counts.value': '{pages} halaman · {articles} artikel · {products} produk · {media} file',
  'site.syncError': 'Sinkronisasi terakhir gagal: {error}',
  'site.usage': 'Penggunaan',
  'site.usage.noData': 'Belum ada data penggunaan. Sinkronkan situs untuk membacanya.',
  'site.limit.pages': 'Halaman',
  'site.limit.users': 'Pengguna aktif',
  'site.limit.languages': 'Bahasa konten',
  'site.limit.items': 'Item katalog',
  'site.limit.articles': 'Artikel',
  'site.limit.storage': 'Penyimpanan media (MB)',
  'site.limit.domains': 'Domain sendiri',
  'site.unlimited': 'Tanpa batas',
  'site.usedOf': '{used} dari {limit}',
  'site.usedOnly': '{used} digunakan',
  'site.plan': 'Paket',
  'site.plan.hint': 'Perubahan dikirim ke situs dan dikonfirmasi sebelum disimpan di sini.',
  'site.plan.package': 'Paket',
  'site.plan.flags': 'Fitur',
  'site.plan.limits': 'Batas',
  'site.plan.default': 'Bawaan paket',
  'site.plan.on': 'Selalu aktif',
  'site.plan.off': 'Selalu nonaktif',
  'site.plan.defaultOn': 'bawaan: aktif',
  'site.plan.defaultOff': 'bawaan: nonaktif',
  'site.plan.custom': 'Angka khusus',
  'site.plan.defaultLimit': 'Bawaan paket ({value})',
  'site.plan.save': 'Simpan paket',
  'site.plan.saving': 'Menyimpan…',
  'site.plan.saved': 'Paket disimpan dan dikonfirmasi oleh situs',
  'site.plan.confirm.title': 'Ubah paket {name}?',
  'site.plan.confirm.body': 'Situs langsung beralih ke {package}. Konten yang melebihi batas lebih rendah tetap dapat dibaca tetapi tidak dapat ditambah.',
  'site.plan.confirm.action': 'Ubah paket',
  'site.plan.noChange': 'Tidak ada perubahan untuk disimpan.',
  'site.details': 'Detail',
  'site.details.save': 'Simpan detail',
  'site.details.saved': 'Detail disimpan',
  'site.details.secretReplace': 'Control secret baru',
  'site.details.secretReplaceHint': 'Kosongkan untuk mempertahankan secret saat ini.',
  'site.suspension': 'Penangguhan',
  'site.suspension.hint': 'Situs yang ditangguhkan ditutup bagi pengguna CMS-nya sendiri. Website publik tetap berjalan. Staf console tetap dapat masuk.',
  'site.suspend': 'Tangguhkan situs',
  'site.reactivate': 'Aktifkan kembali situs',
  'site.suspend.title': 'Tangguhkan {name}?',
  'site.suspend.body': 'Pengguna CMS-nya tidak dapat masuk sampai Anda mengaktifkannya kembali.',
  'site.suspended': 'Situs ditangguhkan',
  'site.reactivated': 'Situs diaktifkan kembali',
  'site.remove': 'Hapus dari console',
  'site.remove.title': 'Hapus {name} dari console?',
  'site.remove.body': 'Situsnya sendiri tidak disentuh; hanya berhenti dikelola di sini.',
  'site.removed': 'Situs dihapus dari console',
  'site.flag.cms': 'Akses CMS untuk pelanggan',
  'site.flag.blog': 'Blog / berita',
  'site.flag.lead_capture': 'Penangkapan prospek',
  'site.flag.booking': 'Sematan booking',
  'site.flag.rename_types': 'Ubah nama tipe katalog',
  'site.flag.custom_types': 'Tambah dan hapus tipe katalog',
  'site.flag.rbac': 'Peran kustom (RBAC)',
  'site.flag.multi_location': 'Beberapa lokasi',
  'site.flag.custom_domain': 'Domain sendiri',
  'site.flag.store': 'Toko online',
  'site.flag.mailbox': 'Kotak masuk (email ke domain situs)',
  'site.flag.ai_writing': 'Asisten penulisan AI',
  'site.flag.seo': 'Kolom dan pengaturan SEO',
  'site.flag.tracking': 'Tracking (Google Analytics, Meta Pixel, TikTok)',
  'site.plan.scopeContent': 'Paket ini cuma membuka edit halaman, katalog, dan media di CMS: tanpa pengaturan situs, navigasi, pengguna, artikel, atau penawaran masuk. Staf console tidak dibatasi.',
  'apiError.siteNotFound': 'Situs tidak ditemukan',
  'apiError.siteExists': 'Situs dengan nama ini sudah ada',
  'apiError.siteUnreachable': 'Situs tidak dapat dijangkau',
  'apiError.siteTimeout': 'Situs tidak menjawab tepat waktu',
  'apiError.siteNoSecret': 'Control secret tidak ada atau tidak dapat dibaca',
  'apiError.siteBadResponse': 'Situs mengirim respons yang tidak terduga',
  'apiError.siteRejected': 'Situs menolak permintaan (periksa control secret dan URL)',
  'apiError.siteUpdateFailed': 'Situs tidak dapat diperbarui',
  'apiError.siteCheckFailed': 'Situs tidak dapat diperiksa',
  'apiError.encryptionKey': 'Kunci enkripsi console belum dikonfigurasi',
  'builds.title': 'Build situs web',
  'builds.hint': 'Build ulang menerbitkan konten CMS terbaru ke situs web publik. Setiap penyimpanan di CMS dan pembaruan kode memulai build dengan sendirinya.',
  'builds.enabled': 'Build aktif untuk situs ini',
  'builds.enabledHint': 'Aktifkan setelah situs punya pipeline yang dapat membangunnya.',
  'builds.rebuild': 'Build ulang sekarang',
  'builds.rebuilding': 'Memulai…',
  'builds.started': 'Build dimulai',
  'builds.configSaved': 'Pengaturan build disimpan',
  'builds.empty': 'Belum ada build.',
  'builds.col.status': 'Status',
  'builds.col.trigger': 'Dimulai oleh',
  'builds.col.when': 'Dimulai',
  'builds.col.finished': 'Selesai',
  'builds.col.message': 'Catatan',
  'builds.status.queued': 'Antre',
  'builds.status.running': 'Berjalan',
  'builds.status.succeeded': 'Berhasil',
  'builds.status.failed': 'Gagal',
  'builds.status.skipped': 'Dilewati',
  'builds.trigger.manual': 'Console',
  'builds.trigger.cms': 'Simpan di CMS',
  'builds.trigger.code': 'Pembaruan kode',
  'builds.trigger.pipeline': 'Pipeline',
  'builds.notConnected': 'Build belum terhubung: console belum memiliki token GitHub atau repositori',
  'apiError.buildOff': 'Build dimatikan untuk situs ini',
  'apiError.buildRunning': 'Build untuk situs ini sedang berjalan',
}

/** The API's fixed English messages about sites (see worker/routes/sites.ts and lib/site-client.ts). */
export const SITE_SERVER_MESSAGE_KEYS: Record<string, keyof typeof siteDetailEn> = {
  'Site not found': 'apiError.siteNotFound',
  'A site with this name already exists': 'apiError.siteExists',
  'The site could not be reached': 'apiError.siteUnreachable',
  'The site did not answer in time': 'apiError.siteTimeout',
  'The control secret is missing or cannot be read': 'apiError.siteNoSecret',
  'The site sent an unexpected response': 'apiError.siteBadResponse',
  'The site could not be updated': 'apiError.siteUpdateFailed',
  'The site could not be checked': 'apiError.siteCheckFailed',
  'The console encryption key is not configured': 'apiError.encryptionKey',
  'Builds are switched off for this site': 'apiError.buildOff',
  'A build for this site is already running': 'apiError.buildRunning',
}
